export default __webpack_public_path__ + "static/ter-icons-3e86eb8fff539bb82bc5f068691a3c98.svg";